module.exports = __webpack_public_path__ + "static/media/client_4.6dc8c9e1.png";